const messages = {
  en: {
    login: {
      success:
        "You have successfully logged in",
    },
    password_change: {
      success:
        "You have successfully change your password, please do re-log in",
    },
    global: {
      add_new: "Add New",
      add_new_option: "Add New Option",
      all: "All",
      all_status: "All Status",
      available: "Available",
      average_price: "Average Price",
      breakdown: "Breakdown",
      cancel: "Cancel",
      cancelConfirm: "Cancel",
      cancelConfirmMessage: "Are you sure you want to cancel and go back? Your changes have not been saved.",
      canceled: "Cancel",
      casting: "Casting",
      category: "Category",
      current_stock: "Current Stock",
      customer: "Customer",
      data_empty: "Data not found",
      date: "Date",
      day: "Day",
      delete: "Delete",
      delete_all: "Delete All",
      delivery: "Delivery",
      detail: "Detail",
      display: "Displaying",
      driver_name: "Driver Name",
      equipment_name: "Equipment name",
      export: "Export",
      file_name: "File Name",
      filter: "Filter",
      filter_label: "Showing result",
      finish: "Finish",
      form_add: "Form add new",
      form_edit: "Form update",
      form_filter: "Filter data",
      go_back: "Back to previous page",
      goto: "Go to",
      import: "Import",
      last_update: "Last Update",
      loading: "Loading",
      material: "Material",
      material_category: "Material Category",
      material_name: "Material Name",
      month: "Month",
      next: "Next",
      of: "of",
      order_number: "Order Number",
      order_volume: "Order Volume",
      other: "Other",
      payment_method: "Payment Method",
      pending: "Pending",
      percentage: "Percentage",
      prev: "Prev",
      produced: "Produced",
      product: "Product",
      product: "Product",
      product_name: "Product Name",
      production_unit: "Production Unit",
      progress: "Progress",
      project: "Project",
      realitation: "Realitation",
      record: "record",
      reload: "Reload",
      remaining: "Remaining",
      result: "Result",
      sales: "Sales",
      salesman: "Salesman",
      salesman_name: "Sales Name",
      schedule: "Schedule",
      scheduled: "Scheduled",
      search: "Search in table",
      search_label: "Search",
      select_all: "Select All in this page",
      select_multiple: "Please select a few",
      select_save: "Save selected item",
      select_single: "Please select",
      selected: "Select Item",
      sent: "Sent",
      status: "Status",
      success: "Success",
      size: "Size",
      table: "Table",
      test_date: "Test Date",
      test_result: "Test Result",
      time: "Time",
      total_price: "Total Price",
      type: "File Type",
      unselected: "Anda belum memilih",
      update: "Edit",
      usage: "Usage",
      view_report: "View Report",
      visibility: "Visibility",
      warehouse: "Warehouse",
      warehouse_location: "Warehouse Location"
    },
    error: {
      view_type: "No visualization for this type",
      no_data: "Data tidak ditemukan"
    },
    hint: {
      upload: "Click image to select a file to upload",
      failed_upload: "File upload canceled",
      max_size: "Maximum file size",
      max_file: "Maximum uploaded file",
      file_type_accept: "File type"
    },
    bag: {
      proyek: "Project",
      m_proyek: "Project Master",
      departemen: "Department",
      pengguna: "User",
      unit_kerja: "Unit Kerja"
    },
    dashboard: {
      production_delivery_title: "Schedule & Production",
      production_time: "Production Time",
      order_title: "Order Data",
      driver_title: "Driver",
      equipment_title: "Equipment Status",
      quality_check_title: "Quality Check",
      material_stock_title: "Material Stock",
      volume_order_title: "Total Order Volume",
      volume_order_desc: "Volume from SO",
      total_so: "Total SO Volume",
      total_so_desc: "Volume Order from SO (Without PPN)",
      production_schedule_title: "Production Schedule",
      production_schedule_desc: "Order scheduled",
      total_schedule: "Total Schedule Volume",
      total_schedule_desc: "Order volume from schedule (Without PPN)",
      production_title: "Production",
      production_desc: "Total Production Volume",
      total_production_title: "Schedule",
      total_production_desc: "Order volume from production (Without PPN)",
      sales_report_title: "Sales Report",
      progress_order_title: "Order Progress",
      progress_order_desc: "Calculated based on order volume at",
      graphic_production_title: "Production Graphic",
      history_stock_take_title: "Stock Take History",
      equipment_title: "Equipment Status",
      latest_quality_check_title: "Quality Check",
      production_schedule_text: "production schedule",
      production_text: "actual production",
      progress_text: "production progress based on target",
      material_usage_title: "Material Usage Report"
    },
    sales: {
      payment_progress: "Payment Progress",
      delivery_progress: "Delivery Progress",
      payment_status: "Payment Status",
      order_status: "Order Status",
      total_order_value: "Total Order Value",
      total_order_volume: "Total Order Volume",
      total_delivery: "Delivery",
      total_undelivery: "Remaining",
      total_payment: "Total Pay",
      total_unpay: "Remaining",
      payment_report_title: "Payment Report",
      total_invoice: "Total Invoice",
      remaining_invoice: "Remaining Invoice",
      sales_volume: "Sales Volume"
    },
    production: {
      production_title: "Production",
      total_scheduled: "Total Scheduled",
      total_production: "Total Production",
      total_delivery: "Total Delivery",
      scheduled_volume: "Scheduled",
      production_volume: "Production Volume",
      delivery_progress: "Delivery Progress",
      total_docket: "Total Docket",
      sync: "Synchronized",
      not_sync: "Not Synchronized"
    },
    material: {
      mix_design: "Mix Design",
      material_stock_report_title: "Material Stock"
    },
    menu: {
      // grower-activity > farmers
      grower: 'Grower',
      
      lahans: 'Lahans',
      // AMS > area
      'target-areas': "Target Areas",
      'management-units': "Management Units",
      regions: "Regions",
      // AMS > master area
      'master-target-areas': "Master Target Areas",
      'master-management-units': "Master Management Units",
      'master-regions': "Master Regions",
      // masters > area
      provinces: "Provinces",
      cities: "Cities",
      districts: "Districts",
      villages: "Villages",
      // masters > ethnic
      ethnic: "Ethnic",
      // masters > Biote
      fishs: "Fish",
      "farm-animals": "Farm Animals",
      // masters > trees
      trees: "Tree Library",
      // masters > nursery-locations
      'nursery-locations': "Nursery Locations",
      // masters > project
      'project-type': "Project Type",
      'project-purpose': "Project Purpose",
      'planting-environment': "Planting Environment",
      participants: "Donors / Sponsors",
      'lahan-cover-types': "Land Cover Types",
      'cultivation-types': "Cultivation Types",
      'lahan-status': "Land Status",
      'lahan-types': "Land Types",
      'soil-types': "Soil Types",
      'legal-land-categories': "Legal Land Categories",
      'planting-types': "Planting Types",
      'planting-patterns': "Planting Patterns",
      // masters > position roles
      roles: "Position & Job Roles",
      'role-groups': "Departement",
      'task-groups': "Task Groups",
      tasks: "Task",
      // masters > options section
      fertilizers: "Fertilizers",
      pesticides: "Pesticides",
      legals: "Legals",
      'business-types': "Business Types",
      'lahan-uses': "Land Uses",
      'land-coverage-types': "Jenis Cakupan Lahan",
      'rt-relationships': "RT Relationships",
      'economic-activities': "Economic Activities",
      'lahan-ownerships': "Land Ownerships",
      irrigations: "Irrigations",
      'tree-conditions': "Tree Conditions",
      'harvest-systems': "Harvest Systems",
      'smaller-harvest-areas': "Smaller Harvest Areas",
      'production-uses': "Production Uses",
      'livestock-groups': "Livestock Groups",
      'livestock-feed-types': "Livestock Feed Types",
      'production-types': "Production Types",
      'livestock-purposes': "Livestock Purposes",
      'wood-harvest-types': "Wood Harvest Types",
      'wood-production-types': "Wood Production Types",
      uoms: "Units of Measure",
      'cultivation-activity-types': "Cultivation Activity Types",
      'receptacle-types': "Receptacle Types",
      'cultivation-systems': "Cultivation Systems",
      'cultivation-technologies': "Cultivation Technologies",
      // masters > user-activity-type
      'user-activity-type': "Action & Status",
      // masters > user-activities
      'user-activities': "Log Activity",
      // masters > configs
      configs: "Configs",
      // employees
      employees: "Employees",
      'field-facilitators': "Field Facilitator",
      // users
      users: "Users",
      'journal-kegiatan': "Activity Journal",
    },
    table_head: {
      access_level: "Access Level",
      account_name: "Account Name",
      account_number: "Account Number",
      actual_usage: "Actual Usage",
      address: "Address",
      attachment: "Attachment",
      available: "Available",
      average_selling_price: "Average Selling Price",
      breakdown: "Breakdown",
      buy_date: "Buy Date",
      capacity_hour: "Capacity / Hour",
      casting: "Casting",
      casting_category: "Casting Category",
      casting_name: "Casting Name",
      category: "Category",
      category_name: "Category Name",
      code: "Code",
      condition: "Condition",
      current_stock: "Current Stock",
      current_thick: "Current Thick",
      current_volume: "Current Volume",
      customer: "Customer",
      date: "Date",
      delivered: "Delivered",
      delivery: "Delivery",
      delivery_progress: "Delivery Progress",
      delivery_schedule: "Delivery Schedule",
      density: "Density",
      desc: "Desc.",
      description: "Description",
      district_city: "District / City",
      docket_number: "Docket Number",
      document_name: "Document Name",
      driver: "Driver",
      driver_license_expired: "Driver License Expired",
      driver_name: "Driver Name",
      email: "Email",
      end: "End",
      ending_stock: "Ending Stock",
      equipment: "Equipment",
      equipment_category: "Equipment Category",
      equipment_name: "Equipment Name",
      error: "Error",
      filler_date: "Filler Date",
      flow_end: "Flow End",
      flow_start: "Flow Start",
      fuel_fill_date: "Fuel Fill Date",
      fuel_filler: "Fuel Filler",
      fuel_filler_name: "Fuel Filler Name",
      fuel_total: "Total Liter",
      gain_loss: "Gain/Loss",
      index: "Index",
      input_type: "Input Type",
      km_end: "KM End",
      km_start: "KM Start",
      last_update: "Last Update",
      lower_limit: "Lower Limit",
      manufacture: "Manufacture",
      material: "Material",
      material_category: "Material Category",
      material_name: "Material Name",
      maximum_stock: "Max. Stock",
      mc: "MC",
      merk: "Merk",
      minimum_stock: "Min. Stock",
      mix_design_volume: "Mix Design Volume",
      mixing_schedule: "Mixing Schedule",
      mode: "Mode",
      module_access: "Module Access",
      name: "Name",
      note: "Note",
      number: "Number",
      opening: "Opening",
      order_date: "Order Date",
      order_number: "Order Number",
      order_status: "Order Status",
      order_volume: "Order Volume",
      payment_channel: "Payment Channel",
      payment_method: "Payment Method",
      payment_progress: "Payment Progress",
      payment_status: "Payment Status",
      permission: "Permission",
      phone_number: "Phone Number",
      physical_stock: "Physical Stock",
      pic_name: "PIC Name",
      pic_phone: "PIC Phone",
      position: "Position",
      price: "Price",
      produced: "Produced",
      produced_volume: "Produced Volume",
      product: "Product",
      product_category: "Product Category",
      product_destination: "Product Destination",
      product_name: "Product Name",
      product_origin: "Product Origin",
      production_schedule: "Production Schedule",
      production_unit: "Production Unit",
      production_unit_name: "",
      production_volume: "Production Volume",
      progress: "Progress",
      project: "Project",
      project_location: "Project Location",
      project_site: "Site Project",
      proof_attachment: "Proof (Attachment)",
      received: "Received",
      received_volume: "Received Volume",
      receiver: "Receiver",
      remaining: "Remaining",
      remaining_invoice: "Remaining Volume",
      rit: "RIT",
      sales_name: "Sales Name",
      sales_volume: "Sales Volume",
      salesman: "Salesman",
      schedule_volume: "Schedule Volume",
      scheduled: "Scheduled",
      sent: "Sent",
      serial_number: "Serial Number",
      start: "Start",
      starting_stock: "Starting Stock",
      status: "Status",
      test_date: "Test Date",
      test_result: "Test Result",
      tester: "Tester",
      theoritical_stock: "Theoritical Stock",
      thick: "Thick",
      time: "Time",
      total_docket: "Total Docket",
      total_invoice: "Total Invoice",
      total_km: "Total KM",
      total_liter: "Total Liter",
      total_order: "Total ORder",
      total_payment: "Total Payment",
      total_price: "Total Price",
      total_product: "Total Product",
      total_received: "Total Received",
      total_volume: "Total Volume",
      transfer_in: "Trf In",
      transfer_number: "Transfer Number",
      transfer_out: "Trf Out",
      truck: "Truck",
      truck_mixer: "Truck Mixer",
      unit_price: "Unit Price",
      uom: "UOM",
      uom_name: "UOM Name",
      updated_by: "Update By",
      updated_date: "Update Date",
      upper_limit: "Upper Limit",
      usage: "Usage",
      usage_date: "Usage Date",
      user_name: "User Name",
      username: "Username",
      vehicle_license_plate: "Vehicle License Plate",
      vendor: "Vendor",
      vendor_category: "Vendor Category",
      vendor_name: "Vendor Name",
      volume_destination: "Volume Destination",
      volume_origin: "Volume Origin",
      warehouse_code: "Warehouse Code",
      warehouse_location: "Warehouse Location",
      warehouse_name: "Warehouse Name",
      warehouse_production_unit: "Warehouse / Production Unit"
    }
  },
  id: {
    login: {
      success:
        "Login Success",
    },
    global: {
      add_new: "Tambah Baru",
      add_new_option: "Tambah Opsi Baru",
      all: "Semua",
      all_status: "Semua Status",
      available: "Tersedia",
      average_price: "Harga Rata-Rata",
      breakdown: "Rusak",
      cancel: "Batal",
      cancelConfirm: "Batalkan",
      cancelConfirmMessage: "Batalkan dan kembali? Data perubahan belum tersimpan.",
      canceled: "Batalkan",
      casting: "Pengecoran",
      category: "Kategori",
      current_stock: "Stok Saat Ini",
      customer: "Pelanggan",
      data_empty: "Data tidak ditemukan",
      date: "Tanggal",
      day: "Hari",
      delete: "Hapus",
      delete_all: "Hapus Semua",
      delivery: "Pengiriman",
      detail: "Detail",
      display: "Menampilkan",
      driver_name: "Nama Driver",
      equipment_name: "Nama Equipment",
      export: "Ekspor",
      file_name: "Nama File",
      filter: "Filter",
      filter_label: "Menampilkan hasil",
      finish: "Selesai",
      form_add: "Tambah",
      form_edit: "Edit",
      form_filter: "Filter data",
      go_back: "Kembali ke halaman sebelumnya",
      goto: "Halaman",
      import: "Impor",
      last_update: "Update Terakhir",
      loading: "Memuat",
      material: "Material",
      material_category: "Kategori Material",
      material_name: "Nama Material",
      month: "Bulan",
      next: "Selanjutnya",
      of: "dari",
      order_number: "No. Order",
      order_volume: "Vol. Order",
      other: "Lainnya",
      payment_method: "Metode Pembayaran",
      pending: "Menunggu",
      percentage: "Presentase",
      prev: "Sebelumnya",
      produced: "Diproduksi",
      product: "Produk (Mutu)",
      product: "Produk",
      product_name: "Nama Produk",
      production_unit: "Unit Produksi",
      progress: "Proses",
      project: "Proyek",
      realitation: "Realisasi",
      record: "data",
      reload: "Muat Ulang",
      remaining: "Sisa",
      result: "Hasil",
      sales: "Penjualan",
      salesman: "Salesman",
      salesman_name: "Nama Sales",
      schedule: "Jadwal",
      scheduled: "Dijadwalkan",
      search: "Cari dalam tabel",
      search_label: "Pencarian",
      select_all: "Pilih semua di halaman ini",
      select_multiple: "Pilih beberapa",
      select_save: "Simpan item",
      select_single: "Pilih salah satu",
      selected: "Item Terpilih",
      sent: "Dikirim",
      size: "Ukuran",
      status: "Status",
      submit: "Simpan Data",
      submit_edit: "Simpan Perubahan",
      success: "Sukses",
      table: "Tabel",
      test_date: "Tgl Tes",
      test_result: "Hasil Tes",
      time: "Jam",
      total_price: "Total Harga",
      type: "Tipe File",
      unselected: "Anda belum memilih",
      update: "Edit",
      usage: "Penggunaan",
      view_report: "Lihat Report",
      visibility: "Tampilkan Kolom",
      warehouse: "Gudang",
      warehouse_location: "Lokasi Gudang"
    },
    menu: {
      // grower-activity > farmers
      grower: 'Grower',
      lahans: 'Lahan',
      // mangrove
      // mangrove pre-activity
      mangrove_scooping_visits: "Scooping Visit Mangrove",
      mangrove_rras: "Pendataan RRA Mangrove",
      mangrove_pras: "Pendataan PRA Mangrove",
      mangrove_program_socializations: "Sosialisasi Program Mangrove",
      mangrove_organization_groups: "Pendataan Organisasi & Grup Mangrove",
      //mangrove data collecting
      mangrove: 'Pendataan Mangrove',
      //mangrove activity 
      mangrove_planting_socialization: 'Sosialisasi Tanam Mangrove',
      mangrove_planting_hole: 'Pendataan Lubang Tanam Mangrove',

      // AMS > area
      'ams-regions': "AMS Regional",
      'ams-management-units': "AMS Management Unit",
      'ams-target-areas': "AMS Target Area",
      'ams-villages': "AMS Desa",
      // AMS > mangrove area
      'ams-management-unit-mangroves': "AMS Management Unit Mangrove",
      'ams-area-mangroves': "AMS Area Mangrove",
      'ams-mangrove-blocks': "AMS Block Mangrove",
      'ams-mangrove-plots': "AMS Plot Mangrove",
      regions: "Regional",
      // AMS > master area
      'master-target-areas': "Master Target Area",
      'master-management-units': "Master Management Unit",
      'master-regions': "Master Regional",
      // masters > area
      provinces: "Provinsi",
      cities: "Kota",
      districts: "Kecamatan",
      villages: "Desa",
      // masters > ethnic
      ethnic: "Suku",
      // masters > Biote
      fishs: "Perikanan",
      'farm-animals': "Peternakan",
      // masters > trees
      trees: "Tree Library",
      // masters > nursery-locations
      'nursery-locations': "Lokasi Persemaian",
      // masters > project
      'projects': "Proyek",
      'project-type': "Jenis Proyek",
      'project-purpose': "Tujuan Proyek",
      'planting-environment': "Media Tanam",
      participants: "Donor / Sponsor",
      'lahan-cover-types': "Jenis Tutupan Lahan",
      'cultivation-types': "Jenis Budidaya",
      'lahan-status': "Status Lahan",
      'lahan-types': "Jenis Lahan",
      'soil-types': "Jenis Tanah",
      'water-sources': "Sumber Air",
      'electricity-sources': "Sumber Energi Listrik",
      'government-place-types': "Tipe Instansi Pemerintahan",
      'mangrove-area': "Area Penanaman Mangrove",
      'legal-land-categories': "Kategori Legalitas Lahan",
      'planting-types': "Jenis Penanaman",
      'planting-patterns': "Pola Tanam",
      'planting-pattern-categories': "Kategori Pola Tanam",
      'planting-pattern-limitations': "Limitasi Pola Tanam",
      'tree-model-harvest-types': "Model Pola Panen",
      'farmer-groups': "Kelompok Tani",
      'business-entities': "Badan Usaha",
      // masters > position roles
      roles: "Position & Job Roles",
      'role-groups': "Departement",
      'task-groups': "Task Group",
      tasks: "Task",
      // masters > options section
      fertilizers: "Pupuk",
      pesticides: "Pestisida",
      legals: "Badan Hukum / Usaha",
      'business-types': "Jenis Usaha",
      'lahan-uses': "Penggunaan Lahan",
      'land-coverage-types': "Tipe Cakupan Lahan",
      'rt-relationships': "Hubungan Kepala RT",
      'economic-activities': "Kegiatan Ekonomi",
      'lahan-ownerships': "Kepemilikan Lahan",
      irrigations: "Irigasi",
      'tree-conditions': "Kondisi Utama Tanaman",
      'harvest-systems': "Sistem Panen",
      'smaller-harvest-areas': "Area Panen Kecil",
      'production-uses': "Penggunaan Produksi",
      'livestock-groups': "Kelompok Ternak",
      'livestock-feed-types': "Jenis Pakan Ternak",
      'production-types': "Jenis Produksi",
      'livestock-purposes': "Tujuan Ternak",
      'wood-harvest-types': "Jenis Panen Kayu",
      'wood-production-types': "Jenis Produksi Kayu",
      uoms: "Satuan Produksi",
      'cultivation-activity-types': "Jenis Kegiatan Budidaya",
      'receptacle-types': "Jenis Wadah",
      'cultivation-systems': "Sistem Budidaya",
      'cultivation-technologies': "Teknologi Budidaya",
      // masters > user-activity-type
      'user-activity-type': "Action & Status",
      // masters > user-activities
      'user-activities': "Log Activity",
      // masters > configs
      configs: "Konfigurasi",
      // employees
      employees: "Employee",
      'field-facilitators': "Field Facilitator",
      // utilities
      'utility-activities': "Activity",
      'utility-area-management': "Area Management",
      'position-project-organization': "Position Project Organization",
      'tree-models': "Pola & Model Pohon",
      'area-management-project': "Area Management Project",
      // users
      users: "User",
      'journal-kegiatan': "Jurnal Kegiatan",
    },

    table_head: {
      access_level: "Akses Level",
      account_name: "Nama Rekening",
      account_number: "No. Rekening",
      actual_usage: "Penggunaan Aktual",
      address: "Alamat",
      attachment: "Lampiran",
      available: "Tersedia",
      average_selling_price: "Average Selling Price",
      breakdown: "Breakdown",
      buy_date: "Tgl Pembelian",
      capacity_hour: "Kapasitas / Jam",
      casting: "Pengecoran",
      casting_category: "Tipe Bongkar",
      casting_name: "Nama Pengecoran",
      category: "Kategori",
      category_name: "Nama Kategori",
      code: "Kode",
      condition: "Kondisi",
      current_stock: "Stok s/d Saat Ini",
      current_thick: "Tebal Terkini",
      current_volume: "Volume s/d Saat Ini",
      customer: "Pelanggan",
      date: "Tanggal",
      delivered: "Dikirim",
      delivery: "Pengiriman",
      delivery_progress: "Progres Kirim",
      delivery_schedule: "Jadwal Kirim",
      density: "Density",
      desc: "Ket.",
      description: "Keterangan",
      district_city: "Kota atau Kabupaten",
      docket_number: "No. Surat Jalan",
      document_name: "Nama Dokumen",
      driver: "Supir",
      driver_license_expired: "Masa Berlaku SIM",
      driver_name: "Nama Supir",
      email: "Email",
      end: "Akhir",
      ending_stock: "Stok Akhir",
      equipment: "Peralatan",
      equipment_category: "Tipe Alat",
      equipment_name: "Nama Alat",
      error: "Eror",
      filler_date: "Tgl Pengisian",
      flow_end: "Flow Akhir",
      flow_start: "Flow Awal",
      fuel_fill_date: "Tgl. Pengisian Solar",
      fuel_filler: "Pengisi Solar",
      fuel_filler_name: "Nama Pengisi Solar",
      fuel_total: "Total Liter",
      gain_loss: "Gain / Loss",
      index: "Indeks",
      input_type: "Tipe Isian",
      km_end: "KM Akhir",
      km_start: "KM Awal",
      last_update: "Update Terakhir",
      lower_limit: "Batas Bawah",
      manufacture: "Manufaktur",
      material: "Material",
      material_category: "Kategori Material",
      material_name: "Nama Material",
      maximum_stock: "Maks. Stok",
      mc: "MC",
      merk: "Merk",
      minimum_stock: "Min. Stok",
      mix_design_volume: "Volume Mix Design",
      mixing_schedule: "Jadwal Mixing",
      mode: "Mode",
      module_access: "Akses Modul",
      name: "Nama",
      note: "Catatan",
      number: "Nomor",
      opening: "Opening",
      order_date: "Tgl Order",
      order_number: "No. Order",
      order_status: "Status Order",
      order_volume: "Volume Order",
      payment_channel: "Chanel Pembayaran",
      payment_method: "Metode Pembayaran",
      payment_progress: "Progres Pembayaran",
      payment_status: "Status Pembayaran",
      permission: "Hak Akses",
      phone_number: "No. Telepon",
      physical_stock: "Physical Stok",
      pic_name: "Nama PIC",
      pic_phone: "No. Telp PIC",
      position: "Posisi",
      price: "Harga",
      produced: "Diproduksi",
      produced_volume: "Vol. Diproduksi",
      product: "Produk",
      product_category: "Kategori Produk",
      product_destination: "Produk Tujuan",
      product_name: "Nama Produk",
      product_origin: "Produk Asal",
      production_schedule: "Jadwa Produksi",
      production_unit: "Unit Produksi",
      production_unit_name: "Nama Unit Produksi",
      production_volume: "Vol. Produksi",
      progress: "Capaian",
      project: "Proyek",
      project_location: "Lokasi Proyek",
      project_site: "Lokasi Proyek",
      proof_attachment: "Bukti (Lampiran)",
      received: "Diterima",
      received_volume: "Vol. Penerimaan",
      receiver: "Penerima",
      remaining: "Sisa",
      remaining_invoice: "Sisa Tagihan",
      rit: "Ritasi",
      sales_name: "Nama Sales",
      sales_volume: "Vol. Penjualan",
      salesman: "Salesman",
      schedule_volume: "Vol. Dijadwalkan",
      scheduled: "Dijadwalkan",
      seal_number: "No. Segel",
      sent: "Dikirim",
      serial_number: "No. Seri",
      start: "Mulai",
      starting_stock: "Stok Awal",
      status: "Status",
      test_date: "Tgl Tes",
      test_result: "Hasil Tes",
      tester: "Ditest Oleh",
      theoritical_stock: "Theoritical Stock",
      thick: "Tebal",
      time: "Jam",
      total_docket: "Jml Surat Jalan",
      total_invoice: "Jml Tagihan",
      total_km: "Total KM",
      total_liter: "Total Liter",
      total_order: "Total Order",
      total_payment: "Total Pembayaran",
      total_price: "Total Harga",
      total_product: "Total Produk",
      total_received: "Total Diterima",
      total_volume: "Total Volume",
      transfer_in: "Trf Masuk",
      transfer_number: "No. Transfer",
      transfer_out: "Trf Keluar",
      truck: "Armada",
      truck_mixer: "Armada",
      unit_price: "Harga Satuan",
      uom: "Satuan",
      uom_name: "Nama Satuan",
      updated_by: "Diperbarui Oleh",
      updated_date: "Tgl Diperbarui",
      upper_limit: "Batas Atas",
      usage: "Penggunaan",
      usage_date: "Tgl Penggunaan",
      user_name: "Nama Pengguna",
      username: "Username",
      vehicle_license_plate: "No. Polisi",
      vendor: "Vendor",
      vendor_category: "Kategori Vendor",
      vendor_name: "Nama Vendor",
      volume_destination: "Volume Tujuan",
      volume_origin: "Volume Asal",
      warehouse_code: "Kode Gudang",
      warehouse_location: "Lokasi Gudang",
      warehouse_name: "Nama Gudang",
      warehouse_production_unit: "Gudang / Unit Produksi"
    },
    dashboard: {
      production_delivery_title: "Jadwal Produksi dan Pengiriman",
      production_time: "Jam Produksi",
      order_title: "Data Order",
      driver_title: "Supir",
      equipment_title: "Status Equipment",
      quality_check_title: "Quality Check",
      material_stock_title: "Material Stok",
      volume_order_title: "Total Volume Order",
      volume_order_desc: "Volume dari SO",
      total_so: "Total Nilai SO",
      total_so_desc: "Nilai order dari SO (Tanpa PPN)",
      production_schedule_title: "Rencana Produksi",
      production_schedule_desc: "Order yang sudah dijadwalkan",
      total_schedule: "Total Nilai Rencana Produksi",
      total_schedule_desc: "Nilai order dari rencana (Tanpa PPN)",
      production_title: "Realisasi Produksi",
      production_desc: "Total Nilai Realisasi Produksi",
      total_production_title: "Realisasi Produksi",
      total_production_desc: "Nilai order dari realisasi (Tanpa PPN)",
      sales_report_title: "Laporan Penjualan",
      progress_order_title: "Data Progress Order",
      progress_order_desc: "Dihitung berdasarkan data order yang masuk di",
      graphic_production_title: "Grafik Realisasi Produksi",
      history_stock_take_title: "Riwayat Stock Take",
      equipment_title: "Status Equipment",
      latest_quality_check_title: "Quality Check",
      production_schedule_text: "jadwal produksi",
      production_text: "produksi aktual",
      progress_text: "capaian produksi berdasarkan target",
      material_usage_title: "Laporan Penggunaan Material"
    },
    sales: {
      payment_progress: "Progress Bayar",
      delivery_progress: "Progress Kirim",
      payment_status: "Status Pembayaran",
      order_status: "Status Order",
      total_order_value: "Total Nilai Order",
      total_order_volume: "Total Volume Order",
      total_delivery: "Sudah Dikirim",
      total_undelivery: "Belum Dikirim",
      total_payment: "Sudah Dibayarkan",
      total_unpay: "Belum Dibayarkan",
      payment_report_title: "Total Pembayaran",
      total_invoice: "Total Tagihan",
      remaining_invoice: "Sisa Tagihan",
      sales_volume: "Volume Penjualan"
    },
    production: {
      production_title: "Realisasi Produksi",
      total_scheduled: "Total Dikirim",
      total_production: "Total Produksi",
      total_delivery: "Total Kirim",
      scheduled_volume: "Vol Dijadwalkan",
      production_volume: "Vol Diproduksi",
      delivery_progress: "Progress Pengiriman",
      total_docket: "Jml Surat Jalan",
      sync: "Tersinkron",
      not_sync: "Belum Tersinkron"
    },

    material: {
      mix_design: "Komposisi",
      material_stock_report_title: "Laporan Stok Material"
    },
    error: {
      view_type: "Maaf, tidak ada visualisasi untuk tipe ini",
      no_data: "Maaf, opsi data tidak ditemukan"
    },
    hint: {
      upload: "Klik gambar untuk memilih berkas yang akan diunggah",
      failed_upload: "Upload berkas dibatalkan",
      max_size: "Ukuran berkas maksimal",
      max_file: "Jumlah file maksimal",
      file_type_accept: "Tipe yang diijinkan"
    },
    bag: {
      proyek: "Proyek",
      m_proyek: "Master Proyek",
      departemen: "Departemen",
      pengguna: "Pengguna",
      unit_kerja: "Unit Kerja"
    }
  }
};

export default messages;



// WEBPACK FOOTER //
// ./src/utils/translate.js